module.exports = __webpack_public_path__ + "img/check_24.538e7b45.svg";